module.exports = __webpack_public_path__ + "static/media/cover8.c341a5bb.jpeg";